export enum ECMRTypes {
    CMR = "CMR", 
    DCA = "DCA",
    PortChart = "PortChart",
    None = "None"
}
